module.exports = "<protection-widget widget-name=\"{{'dashboard.panel.virtualMachines.title'|translate}}\"\n                   widget-state=\"app.virtualmachines\"\n                   items=\"$ctrl.data\"\n                   widget-title-tooltip=\"{{::'dashboard.panel.virtualMachines.descriptionTooltip'|translate}}\"\n                   render-counter=\"$ctrl.renderCounter\"\n                   cursor-pointer=\"true\"></protection-widget>"


//////////////////
// WEBPACK FOOTER
// ./src/azurebackup/views/dashboard/components/virtualMachinesWidget/virtualMachinesWidget.template.html
// module id = 488
// module chunks = 0